import request from "@/libs/request";

import { CommonResponse } from "@/types/common";
import {
  GetDashbaordProductRatioResponse,
  GetDashboardBidSummaryResponse,
  GetDashboardMonthlyBidCountResponse,
  GetDashboardProjectSummaryResponse,
  GetDivisionListResponse,
  GetDminsByContractCountResponse,
  GetMonthlyBidNoticeContractAmountStatsResponse,
  GetMonthlyProductRatioStatsResponse,
  GetProjectDetailsResponse,
  GetSmfRatioStatsResponse,
  GetStatsByContractAmountResponse,
  GetStatsByContractCountResponse,
  GetStatsByProductsResponse,
  GetTargetAchievementResponse,
  GetRawContractsResponse,
  GetAgencyBudgetsResponse,
  GetAgencyBudgetsByTypeResponse,
  GetMonthlyThermoRatioResponse,
  GetBuyerTypeMarginsResponse,
  GetTopBuyersByScenarioResponse,
  GetWinnerTopBuyersResponse,
  GetAgencyFilterResponse,
  CreateAgencyFilterResponse,
  DeleteAgencyFilterResponse,
} from "@/types/dashboard";

export const GetDivisionList = async () =>
  request.post<CommonResponse<GetDivisionListResponse>>(`/compute`, {
    input: "dashboard.settings.get_divisions()",
  });

export const GetDashboardBidSummary = async (params: string) =>
  request.post<CommonResponse<GetDashboardBidSummaryResponse>>(`/compute`, {
    input: `dashboard.get_bid_notice_summary(${params})`,
  });
export const GetMonthlyBidCount = async (params: string) =>
  request.post<CommonResponse<GetDashboardMonthlyBidCountResponse>>(
    `/compute`,
    {
      input: `dashboard.get_monthly_bid_notice_count_stats(${params})`,
    }
  );
export const GetProductRatio = async (params: string) =>
  request.post<CommonResponse<GetDashbaordProductRatioResponse>>(`/compute`, {
    input: `dashboard.get_product_ratio(${params})`,
  });
export const GetStatsByProducts = async (params: string) =>
  request.post<CommonResponse<GetStatsByProductsResponse>>(`/compute`, {
    input: `dashboard.get_stats_by_products(${params})`,
  });

export const GetMonthlyBidNoticeContractAmountStats = async (params: string) =>
  request.post<CommonResponse<GetMonthlyBidNoticeContractAmountStatsResponse>>(
    `/compute`,
    {
      input: `dashboard.get_monthly_bid_notice_contract_amount_stats(${params})`,
    }
  );
export const GetMonthlyProductRatioStats = async (params: string) =>
  request.post<CommonResponse<GetMonthlyProductRatioStatsResponse>>(
    `/compute`,
    {
      input: `dashboard.get_monthly_product_ratio_stats(${params})`,
    }
  );

export const GetStatsByContractAmount = async (params: string) =>
  request.post<CommonResponse<GetStatsByContractAmountResponse>>(`/compute`, {
    input: `dashboard.get_stats_by_contract_amount(${params})`,
  });

export const GetDashboardProjectSummary = async (params: string) =>
  request.post<CommonResponse<GetDashboardProjectSummaryResponse>>(`/compute`, {
    input: `dashboard.get_project_summary(${params})`,
  });

export const GetTargetAchievement = async () =>
  request.post<CommonResponse<GetTargetAchievementResponse>>(`/compute`, {
    input: `dashboard.settings.get_target_achievement()`,
  });

export const SetExchangeRate = async (params: number) =>
  request.post(`/compute`, {
    input: `dashboard.settings.set_exchange_rate(exchange_rate=${params})`,
  });

export const GetSmfRatioStats = async (params: string) =>
  request.post<CommonResponse<GetSmfRatioStatsResponse>>(`/compute`, {
    input: `dashboard.get_smf_ratio_stats(${params})`,
  });

export const GetStatsByContractCount = async (params: string) =>
  request.post<CommonResponse<GetStatsByContractCountResponse>>(`/compute`, {
    input: `dashboard.get_stats_by_contract_count(${params})`,
  });

export const GetDminsByContractCount = async (params: string) =>
  request.post<CommonResponse<GetDminsByContractCountResponse>>(`/compute`, {
    input: `dashboard.get_dmins_by_contract_count(${params})`,
  });

export const SetTargetArchievement = async (params: string) =>
  request.post(`/compute`, {
    input: `dashboard.settings.set_target_achievement(${params})`,
  });

export const GetProjectDetails = async (params: string) =>
  request.post<CommonResponse<GetProjectDetailsResponse>>(`/compute`, {
    input: `dashboard.get_project_details(${params})`,
  });

// 입찰공고 탭 계약 목록
export const GetRawContracts = async (params: string) =>
  request.post<CommonResponse<GetRawContractsResponse>>(`/compute`, {
    input: `dashboard.get_raw_contracts(${params})`,
  });

// 수요기관별 집행예산
export const GetAgencyBudgets = async (params: string) =>
  request.post<CommonResponse<GetAgencyBudgetsResponse>>(`/compute`, {
    input: `dashboard.get_agency_budgets(${params})`,
  });

// 수요기관별 소모품 및 장비 비율
export const GetAgencyBudgetsByType = async (params: string) =>
  request.post<CommonResponse<GetAgencyBudgetsByTypeResponse>>(`/compute`, {
    input: `dashboard.get_agency_budgets_by_type(${params})`,
  });

// 월별 SMF/TPP 비중
export const GetMonthlyThermoRatio = async (params: string) =>
  request.post<CommonResponse<GetMonthlyThermoRatioResponse>>(`/compute`, {
    input: `dashboard.get_monthly_thermo_ratio(${params})`,
  });

// 디비전별 마진 금액
export const GetBuyerTypeMargins = async (params: string) =>
  request.post<CommonResponse<GetBuyerTypeMarginsResponse>>(`/compute`, {
    input: `dashboard.get_buyer_type_margins(${params})`,
  });

// 구매업체별 Top 5 매입가 합계 & 비중
export const GetTopBuyersByScenario = async (params: string) =>
  request.post<CommonResponse<GetTopBuyersByScenarioResponse>>(`/compute`, {
    input: `dashboard.get_top_buyers_by_scenario(${params})`,
  });

// 낙찰된 업체의 구매업체 비율
export const GetWinnerTopBuyers = async (params: string) =>
  request.post<CommonResponse<GetWinnerTopBuyersResponse>>(`/compute`, {
    input: `dashboard.get_winner_top_buyers(${params})`,
  });

// 수요기관 필터 읽기
export const GetAgencyFilter = async () =>
  request.post<CommonResponse<GetAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_read()`,
  });

// 수요기관 필터 쓰기
export const CreateAgencyFilter = async (clientId: string) =>
  request.post<CommonResponse<CreateAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_create(client_id="${clientId}")`,
  });

// 수요기관 필터 삭제
export const DeleteAgencyFilter = async (clientId: string) =>
  request.post<CommonResponse<DeleteAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_delete(client_id="${clientId}")`,
  });
